<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("fnbWastage") }}</div>
      </div>
      <div>
        <b-button
          v-if="$can('create', 'Waste Management')"
          variant="default"
          to="add-fnb-wastage"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>
    <br />

    <div
      v-if="selectedCinema != '' && selectedConcession != ''"
      class="d-flex justify-content-between align-items-center my-3"
    >
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <FilterByStatusDropdown
          :onSelect="
            (filterIsActive) => getFnbWastages(concessionid, filterIsActive)
          "
        />
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <!-- <div class="viewing-status">
          {{ $t('viewing')}}
          <span>1-20</span>of
          <span>36</span>
          <button class="btn-prev mx-2"></button>
          <button class="btn-next"></button>
        </div>-->
        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(waste, wasteKey) in fnb_wastages"
        :key="wasteKey"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ waste.rm_name }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  @click="goToRoute('/fnb/view-fnb-wastage', waste)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <div class="count">059</div>
              <div class="text">
                No of
                <br />employees
              </div>
            </div>
            <div class="d-flex align-items-end">
              <!-- <label class="ios-switch">
                <input
                  :checked="waste.fw_is_active == 'Y' ? true : false"
                  type="checkbox"
                  class="ios-checkbox"
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot
                :status="
                  waste.fw_is_active === 'Y'
                    ? 'active'
                    : waste.fw_is_active === 'N' && 'inactive'
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <div class="white-wrapper">
      <div class="row">
        <div class="col-md-6 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema.length > 0 ? 'shift-up' : ''">{{
              $tc("cinema", 1)
            }}</label>
            <div class>
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <!-- _getCountryList(item.label, null) -->
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in cinemaList"
                  :key="dropdownIndex"
                  href="#"
                  @click="onDropdownChange($event, dropdownItem)"
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedConcession.length > 0 ? 'shift-up' : ''">{{
              $tc("concession", 1)
            }}</label>
            <div class>
              <b-dropdown
                :text="selectedConcession"
                variant="dropdown-curve"
                class="w-100"
              >
                <!-- _getCountryList(item.label, null) -->
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in concessionLevels"
                  :key="dropdownIndex"
                  href="#"
                  @click="onDropdownChange1($event, dropdownItem)"
                  >{{ dropdownItem.sm_store_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>
      <table class="list-view-table" v-if="listView">
        <thead>
          <tr>
            <th class="text-left">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
            <th>
              <img
                v-if="this.columnName != 'rm_name'"
                @click="onSortValue('rm_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('rm_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('rm_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $tc("rawmaterials", 2) }}
            </th>
            <th>{{ "Is Item Wastage" }}</th>
            <th>{{ $tc("quantity", 2) }}</th>
            <th>{{ $tc("approvedby", 2) }}</th>
            <th>
              <img
                v-if="this.columnName != 'fw_date'"
                @click="onSortValue('fw_date', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('fw_date', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('fw_date', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $tc("date", 2) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(waste, wasteKey) in fnb_wastages" :key="wasteKey">
            <!-- <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    waste.fw_is_active === 'Y'
                      ? 'active'
                      : waste.fw_is_active === 'N' && 'inactive'
                  "
                />

                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item
                    @click="goToRoute('/fnb/view-fnb-wastage', waste)"
                  >
                    <span class="icon-eye mr-1"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="waste.fw_is_active === 'Y' ? 'active' : 'inactive'"
                />

                <i
                  class="icon-eye blue-icon cursor-pointer ml-4"
                  @click="goToRoute('/fnb/view-fnb-wastage', waste)"
                  v-b-tooltip="'View'"
                  tabindex="0"
                ></i>
              </div>
            </td>

            <td>
              {{ waste.rm_name }}
            </td>
            <td>
              {{ waste.unique_id ? waste.unique_id : "" }} -
              {{ waste.item_name ? waste.item_name : "" }}
            </td>
            <td>{{ waste.fw_quantity }} {{ waste.uom_unit }}</td>
            <td>
              {{
                waste.first_name +
                (waste.last_name ? " " + waste.last_name : "")
              }}
            </td>
            <td>{{ waste.fw_date | dateparse }}</td>
          </tr>
          <tr v-if="fnb_wastages.length == 0" class="text-center">
            <td colSpan="4">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      cinemaListCopy: [],
      searchCinema: "",
      isRoleID: true,
      concessionid: "",
      getitem: "",
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      gridView: false,
      listView: true,
      fnb_wastages: [],
      cinemaList: [],
      concessionLevels: [],
      cinema_id: "",
      selectedCinema: "",
      selectedConcession: "",

      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemaList(obj);
    this.getviewingnumber();
  },
  mounted() {
    // this.getConcessionLevels();
    // this.getpricinglist();
  },
  methods: {
    onSortValue(columnName, orderBy) {
      if (this.concessionid.length == 0) {
        return this.$toasted.show("Please select Concession");
      }
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getFnbWastages(this.concessionid);
    },
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.cinemaList = this.cinemaListCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.cinemaList = this.cinemaListCopy;
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getFnbWastages(this.concessionid);
      } else {
        this.currentPage = event;
        this.getFnbWastages(this.concessionid);
      }
    },
    getConcessionLevels: function (cinema_id) {
      this.concessionLevels = [];
      this.fnb_wastages = [];
      this.selectedConcession = "";
      // let payload = {
      //   tableName: "store_management",
      //   sm_is_active: "Y",
      //   cinema_id: cinema_id
      // };
      MasterService.GetStoreManagement({ cine_id: cinema_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.concessionLevels = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getCinemaList: function (cine_id) {
      // let body = this.getRequestBody("GET", undefined, {
      //   GET: "/admin/",
      //   tableName: "ms_cinemas"
      // });
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      // MasterService.GlobalRequest(body)
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            // console.log("data :", data);
            this.cinemaList = data.Records;
            this.cinemaListCopy = data.Records;
            this.cinemaList.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selectedCinema = x.cine_name;
                // this.getitem = x.cine_id;
                // this.getConcessionLevels(x.cine_id);
                this.onDropdownChange(null, x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    onDropdownChange: function (event, item) {
      this.selectedCinema = item.cine_name;
      this.cinema_id = item.cine_id;
      this.searchCinema = "";
      this.onSearchCinema();
      this.getConcessionLevels(item.cine_id);
    },
    onDropdownChange1: function (event, item) {
      // console.log("item :", item);
      this.selectedConcession = item.sm_store_name;
      this.cinema_id = item.cinema_id;
      this.concessionid = item.sm_id;
      this.getFnbWastages(item.sm_id);
    },
    getFnbWastages: function (sm_id, filterIsActive = "Y") {
      this.fnb_wastages = [];
      let cinema_id = this.cinema_id;
      // concession_level_id: cl_id,
      // console.log("cl_id :", cl_id);
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderBy,
        filterIsActive,
      };
      // console.log("payload :", payload);
      PosFnbService.GetAllFnbWastages({ sm_id, cinema_id }, payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.fnb_wastages = data.Records;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    goToRoute: function (path, { fw_id }) {
      this.$router.push({
        path: path,
        query: {
          fw_id: fw_id,
        },
      });
    },
    /* eslint-disable */

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FnbWastageComponents/fnbWastage.vue